import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

export function initializeFlamingo(): () => Observable<unknown> {
  return () => {
    return of().pipe(
      // eslint-disable-next-line no-console -- init flamingo
      tap(_ => console.log('Startup Flamingo Services')),
    );
  };
}
